import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M24 2H0v4h24V2zM24 10H0v4h24v-4zM16 18H0v4h16v-4z"
            fill={props.isHover ? '#ffffff' : theme["#0EA59D"]}
        />
        </svg>
    )
}

export default SvgComponent